import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "burger"]

  initialize() {
    this._open = false
  }

  toggle() {
    this._open = !this._open
    this._updateState()
  }

  close() {
    this._open = false
    this._updateState()
  }

  backdropClose(event) {
    if (event.target === event.currentTarget) this.close()
  }

  disconnect() {
    document.body.style.overflow = ""
  }

  _updateState() {
    const open = this._open
    const spans = this.burgerTarget.querySelectorAll("span")

    spans[0]?.classList.toggle("translate-y-[3.5px]", open)
    spans[0]?.classList.toggle("rotate-45", open)
    spans[1]?.classList.toggle("-translate-y-[3.5px]", open)
    spans[1]?.classList.toggle("-rotate-45", open)

    this.drawerTarget.classList.toggle("opacity-0", !open)
    this.drawerTarget.classList.toggle("pointer-events-none", !open)
    this.drawerTarget.classList.toggle("opacity-100", open)
    this.drawerTarget.classList.toggle("pointer-events-auto", open)

    document.body.style.overflow = open ? "hidden" : ""
  }
}
